import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="notfound-page">
      {/* SEO */}
      <SEO
        title="404 | Page Not Found"
        description="The page you are looking for does not exist or has been moved."
        url="https://yourdomain.com/404"
      />

      <section className="notfound-hero">
        <div className="container text-center">
          <h1 className="error-code">404</h1>
          <h2 className="error-title">Page Not Found</h2>
          <p className="error-text">
            Sorry, the page you’re looking for doesn’t exist or has been moved.
          </p>

          <div className="notfound-actions">
            <Link to="/" className="btn btn-dark btn-lg">
              Go to Homepage
            </Link>

            <Link to="/products" className="btn btn-outline-dark btn-lg">
              View Products
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
